import { fCurrency, fData, fNumber, fPercent, fShortenNumber } from "./formatNumber";

export const formatNumber = (number, format) => {
	switch (format) {
		case "currency":
			return fCurrency(number);
		case "percent":
			return fPercent(number);
		case "shorten":
			return fShortenNumber(number);
		case "shortencurrency":
			return fCurrency(fShortenNumber(number));
		case "data":
			return fData(number);
		default:
			return fNumber(number);
	}
};
